export default "__VITE_ASSET__BdVo80A0__";